import { render, staticRenderFns } from "./FutureGoals.vue?vue&type=template&id=0844a256&"
import script from "./FutureGoals.vue?vue&type=script&lang=js&"
export * from "./FutureGoals.vue?vue&type=script&lang=js&"
import style0 from "./FutureGoals.vue?vue&type=style&index=0&id=0844a256&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports